import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import installmentService from "../../../services/installment.service";

const initialValues = {
  title: "",
  description: "",
  isActive: true,
};
const schema = Yup.object().shape({
    title: yupSchema.title128,
});
const form = [
  {
    _type: "textField",
    name: "title",
    label: "عنوان",
    autoFocus: true,
  },
  {
    _type: "textField",
    name: "count",
    label: "تعداد اقساط",
    autoFocus: false,
    type: "number",
  },
  {
    _type: "textField",
    name: "description",
    multiline: true,
    rows: 10,
    label: "توضیحات",
    autoFocus: false,
  },
  {
    _type: "filePicker",
    name: "image",
    label: "عکس",
    isImage: true,
  },
  {
    _type: "switch",
    name: "isActive",
    label: "فعال",
  },
];

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {

    let op;
    if (data?.id) {
      op = await installmentService.editInstallment(data.id, model);
    } else {
      op = await installmentService.createInstallment(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "فرم خرید قسطی",
        data,
        schema,
        initialValues: {
            ...initialValues,
            ...data
        },
        handleSubmit,
        form,
      }}
    />
  );
}
